import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id BBE325B3-416A-4160-8E95-162B076B8839
 * name wallet-membership
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wallet-membership.svg
 * tags
 */
export const WalletMembershipIcon = createSvgIcon(<><path d="M20,10H4V4H20M20,15H4V13H20M20,2H4C2.89,2 2,2.89 2,4V15C2,16.11 2.89,17 4,17H8V22L12,20L16,22V17H20C21.11,17 22,16.11 22,15V4C22,2.89 21.11,2 20,2Z" /></>, 'WalletMembershipIcon');
export default WalletMembershipIcon